export interface TeamMember {
  name: string;
    image: string;
  nl:{
      role: string;
      bio: string;
  },
    en:{
        role: string;
        bio: string;
    }

}

export const teamMembers: TeamMember[] = [
    {
        name: 'Kenneth',
        image: '/images/persons/kenneth.webp',
        nl: {
            role: 'Owner',
            bio: 'Bouwt schaalbare platformen met een sterke focus op architectuur, performance en langetermijnvisie.',
        },
        en: {
            role: 'Owner',
            bio: 'Builds scalable platforms with a strong focus on architecture, performance, and long-term vision.',
        },
    },
    {
        name: 'John',
        image: '/images/persons/john.webp',
        nl: {
            role: 'Lead developer',
            bio: 'Zet complexe uitdagingen om in heldere, onderhoudbare oplossingen door doordachte engineering.',
        },
        en: {
            role: 'Lead developer',
            bio: 'Turns complex challenges into clean, maintainable solutions through thoughtful engineering.',
        },
    },
    {
        name: 'Danilo',
        image: '/images/persons/danilo.webp',
        nl: {
            role: 'Web- en App Developer',
            bio: 'Levert betrouwbare web- en app-oplossingen met oog voor detail en gebruikservaring.',
        },
        en: {
            role: 'Web and App Developer',
            bio: 'Delivers reliable web and app solutions with attention to detail and user experience.',
        },
    },
    {
        name: 'Felix',
        image: '/images/persons/felix.webp',
        nl: {
            role: 'Developer',
            bio: 'Richt zich op het bouwen van veilige, efficiënte backends en goed gestructureerde API’s.',
        },
        en: {
            role: 'Developer',
            bio: 'Focuses on building secure, efficient backends and well-structured APIs.',
        },
    },
    {
        name: 'Kimberly',
        image: '/images/persons/kimberly.webp',
        nl: {
            role: 'Developer',
            bio: 'Zorgt voor stabiele en veilige systemen die producten soepel laten draaien op schaal.',
        },
        en: {
            role: 'Developer',
            bio: 'Ensures stable, secure systems that keep products running smoothly at scale.',
        },
    },
];


export const teamBannerImage =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuCAt52d-ojuLmkB9TNLKavK363tLbow6MZEX-9042CDZB6ayoiT8HCFKBdNPqF4EWrwg2TFnTjfojeJ3R8BX6cg7tkg4wconY4vSTqOj69RL3NUmNbcyrOUPGZWNEGG5JVo-mkrUVeH8y_JFzzqNWucOW6vC5vy7jmHSiI0z5LHNTL2W3nDKJTa74ARWpmeeWb8UrF2IhSpjJuDxPMjee3xECoOHKlyaXI2-x1uhQMvPZhdr5TzEcfVjlaXTNK8KZkdfpSLzh7Z14s';
